import { ParcelScanProvider } from './ParcelScanPageContext';
import ScanScreenContainer from '../../containers/ScanScreenContainer';

export default function ParcelScanPage() {
  return (
    <ParcelScanProvider>
      <ScanScreenContainer />
    </ParcelScanProvider>
  );
}
